import { useQuery } from "@tanstack/react-query";

import { MattersAPI } from "@/api/matters";

import { countVisas } from "../visaCounts";

/** How many matters to count; a firm's active book fits well inside this. */
const SAMPLE = 500;

/**
 * The visa types the signed-in firm's cases are on, most first, for
 * suggesting searches. The server scopes the list to the caller's firm.
 */
export const useFirmVisaCounts = () =>
  useQuery({
    queryKey: ["research", "firm-visas"],
    queryFn: async () => {
      const { matters } = await MattersAPI.list({ limit: SAMPLE });
      return countVisas(matters);
    },
    staleTime: 10 * 60_000,
    retry: false
  });
